import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import ObtenerProvincias from '../functions/ObtenerProvincias';
import ObtenerPais from '../functions/ObtenerPais';
import ProvinciaTabla from '../types/ProvinciaTabla';
import RubroSeleccionar from '../types/RubroSeleccionar';
import ProvinciaSeleccionar from '../types/ProvinciaSeleccionar';
//import ObtenerRubro from '../functions/ObtenerRubro';
import ObtenerRubros from '../functions/ObtenerRubros';

interface SeleccionarRubroProps {
    rubroInicial: number;
    onChange: (rubro: RubroSeleccionar | null) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarRubro: React.FC<SeleccionarRubroProps> = ({ rubroInicial, onChange, onClear, eliminando }) => {

    const [rubros, setRubros] = useState<RubroSeleccionar[]>([]);
    const [rubroSeleccionado, setRubroSeleccionado] = useState<RubroSeleccionar | null>({id: 0, name: ''});

    const handleRubroChange = (event: React.SyntheticEvent, newValue: RubroSeleccionar | null) => {

        setRubroSeleccionado(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
    };

    const fetchRubros = async () => {
        
        const dataRubros = await ObtenerRubros('S');
        if (dataRubros.rubros_ok === 'si') {
            const rubrosRecuperados: RubroSeleccionar[] = [];
            for (const rubro of dataRubros.rubros) {
                rubrosRecuperados.push({
                    id: rubro.id,
                    name: rubro.rubro
                });
            }

            setRubros(rubrosRecuperados);

            if (rubroInicial > 0) {
                const rubroInicio = dataRubros.rubros.find(
                    (r: RubroSeleccionar) => r.id === rubroInicial
                );
                if (rubroInicio) {
                    const rubroInicioOK: RubroSeleccionar = {
                        id: rubroInicio.id,
                        name: rubroInicio.rubro
                    };
                    setRubroSeleccionado(rubroInicioOK);
                    onChange(rubroInicioOK);
                }
            }
        }
    };

    useEffect(() => {
        fetchRubros()
    }, []);

    useEffect(() => {
        if (rubroInicial === 0) {
            setRubroSeleccionado(null);
        }
    }, [rubroInicial]);

    /*useEffect(() => {
        fetchRubros()
    }, [rubroInicial]);*/

    return (
        <div className="flex flex-col w-full">
            <Autocomplete<RubroSeleccionar>
                options={rubros}
                getOptionLabel={(option: RubroSeleccionar) => `${option.name}`}
                renderInput={(params) => <TextField {...params} label="Selecciona un rubro"
                sx={{
                        '& .MuiInputBase-root': {
                            height: '39px',
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '4px 14px', // Ajustamos el padding vertical
                            height: '20px', // Reducimos la altura del input
                            display: 'flex',
                            alignItems: 'center',
                        },
                        '& .MuiAutocomplete-input': {
                            padding: '0 !important', // Eliminamos el padding adicional del input del Autocomplete
                        },
                        '& .MuiInputLabel-root': {
                            transform: 'translate(14px, 8px) scale(1)',
                        },
                        '& .MuiInputLabel-shrink': {
                            transform: 'translate(14px, -9px) scale(0.75)',
                        },
                    }}
                />}
                value={rubroSeleccionado}
                onChange={handleRubroChange}
                isOptionEqualToValue={(option: RubroSeleccionar, value: RubroSeleccionar) => option.id === value.id}
                renderOption={(props, option: RubroSeleccionar) => (
                <li {...props}>
                    {option.name}
                </li>
                )}
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarRubro;